import { Theme, css } from '@emotion/react';

export const menuFilterRootStyles = ({ spacing }: Theme) => css`
  padding-top: ${spacing(2)}px;
`;
